/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  Grid,
  TextField,
  Typography,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
import InputField from "./forms/input/TextInput/InputField";
import FormButton from "./ui/button/FormButton";
import { examPrices } from "../partials/examboardprices/examprices";
import data from "./dropDown";
import Spinner from "./ui/Spinner";
import axios from "axios";
import {  useNavigate } from "react-router-dom";
import { API } from "../pages/backend";
import { setTransactionDetails } from "../store/reducers/transactionDetails";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ResponsiveFormButton from "./ui/button/ResponsiveFormButton";
import { closeModal } from "../store/reducers/modal";
import InvoiceButtonWithConfirmation from "./InvoiceButtonWithConfirmation";

const IndividualPayment = ({
  examName,
  examType = "MODEL SCREENING FORM",
  payerID,
}) => {

  const { Lga } = data;
  const [invoiceLoading, setInvoiceLoading] = useState(false);
  const dispatch = useDispatch();
    const [showTimeoutModal, setShowTimeoutModal] = useState(false);
  const [modelPrice, setModelPrice] = useState(
    examPrices.modelCollegeExamFeePerCandidiate
  );
  const token = useSelector((state) => state.user.data.token);
  const [modelCollegeData, setModelCollegeData] = useState([]);
  const navigate = useNavigate();
  const [lga, setLga] = useState();
  console.log(lga);

  const [formData, setFormData] = useState({
    firstName: "",
    middleName: "",
    lastName: "",
    email: "",
  });

  const handlInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value.trim(),
    });
  };

  const priceInt = modelPrice.replace(/\D/g, "");
  const totalFee = priceInt;
  const totalAmount = parseInt(totalFee);

  const saveGeneratedBill = async (body) => {
    try {
      const res = await axios.post(`${API}/bills/create`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
    } catch (error) {}
  };

  const getModelCollegeBillable = async () => {
    const examBillable_url = `${API}/cbs/college_billables`;

    try {
      const res = await axios.get(examBillable_url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res);
      setModelCollegeData(res?.data?.data);
      // console.log(modelCollegeData);
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    getModelCollegeBillable();
  }, []);

  const updateIndividualDetails = async () => {
    // const updateUrl = `${API}individual/02`;
    const updateUrl = `${API}/individual/01`;
    // const updateUrl = examName === "Public Service" ? publicUpdate : modelUpdate;

    try {
      const res = await axios.patch(
        updateUrl,
        { payerID },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      // console.log(res);
    } catch (error) {
      // console.log(error);
    }
  };

  const generateBillNo = async () => {

          // Start the timeout
  let timeoutId = setTimeout(() => {
    setShowTimeoutModal(true);
  }, 120000); // 2 minutes in milliseconds
    const body = {
      payer_id: payerID,
      customer_name: `${formData.firstName} ${formData.lastName}`,
      selected_quantities: [1],
      selected_items: [modelCollegeData?.[1]?.PRODUCTS_ID],
      selected_tariffs: [parseInt(totalFee)],
      assessmentCode: "01",
    };

    try {
      const res = await axios.post(`${API}/cbs/create_invoice`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // console.log(res)
                // If the request completes successfully, clear the timeout
    clearTimeout(timeoutId);
      if (res?.status === 200) {
        updateIndividualDetails();
        // console.log(res?.status);
        // console.log(res?.data);
        // console.log(res?.data?.data?.responseData);

        const billdata = {
          // schoolId: '',
          billNumber: res?.data?.data?.bill_number,
          payerId: payerID,
          amountGenerated: totalFee,
          customerName: `${formData.lastName} ${formData.firstName}`,
          quantity: 1,
          assessmentCode: "01",
          payerInfos: [
            {
              surname: `${formData.lastName}`,
              firstName: `${formData.firstName}`,
              middleName: `${formData.middleName}`,
              locationIdOrExamId: lga,
            },
          ],
        };
        const bill = saveGeneratedBill(billdata);
        // console.log(bill)

        const userTransactionDetails = {
          payerName: `${formData.lastName} ${formData.firstName}`,
          productQuantity: 1,
          // price: amount,
          price: totalFee,
          // schoolName: "",
          // unitPrice: priceInt,
          //   email: user?.email,
          email: formData.email,
          examType,
          paymentExamType: examName,
          fullDesc: "Screening Test Model College[NGN]",
          billNumber: res?.data?.data?.bill_number,
          payerId: payerID,
          //   address: user?.address,
          // schoolName: user?.schoolName,
          priceWithCharge: totalAmount,
        };
        dispatch(setTransactionDetails(userTransactionDetails));
        dispatch(closeModal({ content: <></> }));

        // console.log(userTransactionDetails);
        // console.log(details);

        // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
        // console.log(details)
        navigate("/invoice");
      }
      // console.log(res);
    } catch (error) {
          // If the request completes successfully, clear the timeout
    if (axios.isAxiosError(error)) {
      const backendMessage = error.response?.data?.message || "Something went wrong";
      toast.error(backendMessage);
    } else {
      toast.error("An unexpected error occurred");
    }
  
    }
  };

  const handleInvoiceClick = async (e) => {
    setInvoiceLoading(true);
    try {
      // e.preventDefault();
      if (!lga) {
        throw new Error("Local Government Area is Required.");
      } else if (!formData.firstName || !formData.lastName) {
        throw new Error("First Name and Last Name are Required");
      }
      if (
        formData.firstName.trim().length < 3 ||
        formData.lastName.trim().length < 3
      ) {
        throw new Error(
          "First Name and Last Name are required with a minimum of 3 characters."
        );
      }

      const alphaRegex = /^[A-Za-z]+(-[A-Za-z]+)*$/;

      const regex = /[0-9~`!@#$%^&*()_+=\-[\]\\';,/{}|\\":<>?]/;
      if (!alphaRegex.test(formData.firstName)) {
        throw new Error("First name should contain only alphabetical letters.");
      } else if (!alphaRegex.test(formData.lastName)) {
        throw new Error("Last name should contain only alphabetical letters.");
      }

      await generateBillNo();
      // console.log(transactionDetails)
      // console.log(examName)
    } catch (error) {
      // console.log(error);
      toast.error(error.message);
    } finally {
      setInvoiceLoading(false);
    }
  };

  return (
    <div
      style={{
        padding: "16px",
        maxHeight: "calc(100vh - 160px)",
        overflowY: "auto",
      }}
    >
              {showTimeoutModal && (
        <Modal show={showTimeoutModal} onHide={() => setShowTimeoutModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Server Delay</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            The bill generation is taking longer than expected. This may be due to a delay from our third-party server. Please wait a moment and try again later.
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowTimeoutModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div
        style={{
          // display: "flex",
          // alignItems: "center",
          // gap: "1.5rem",
          padding: "16px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            gap: "20px",
            // padding: "1rem",
          }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
            <InputField
                name="lastName"
                label="Surname "
                type="text"
                placeholder="Enter Last Name"
                value={formData.lastName}
                onChange={handlInputChange}
                style={{ width: "100%" }}
              />

            </Grid>
            <Grid item xs={6} md={6}>
            <InputField
                name="firstName"
                label="First Name"
                value={formData.firstName}
                onChange={handlInputChange}
                placeholder=" Enter First Name"
                type="text"
                style={{ width: "100%" }}
              />

            </Grid>
          </Grid>
        </div>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "32px" }}>
          <Grid container spacing={2}>
            <Grid item xs={6} md={6}>
        \              <InputField
                name="middleName"
                label="Other Name"
                value={formData.middleName}
                onChange={handlInputChange}
                placeholder=" Enter Middle Name"
                type="text"
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <Typography
                variant="body1"
                sx={{
                  color: "#9b9494",
                  fontSize: "1rem",
                  fontWeight: "bolder",
                  paddingTop: "16px",
                }}
              >
                L.G.A
              </Typography>
              <TextField
                label="Select L.G.A"
                select
                value={lga}
                onChange={(e) => setLga(e.target.value)}
                style={{
                  height: "100%",
                  width: "100%",
                }}
              >
                {Lga.map((lgaItem) => (
                  <MenuItem key={lgaItem.ledId} value={lgaItem.ledId}>
                    {lgaItem.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </div>

        <div
          style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <InputField
                name="TotalPrice"
                label="Price Per Cancdidate"
                value={modelPrice}
                // placeholder=" Enter Middle Name"
                type="text"
                // onChange={(e) =>
                //   handleCandidateChange(index, "middleName", e.target.value)
                // }
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={2} style={{ paddingTop: "35px" }}>
                 <InvoiceButtonWithConfirmation
           invoiceLoading={invoiceLoading}
           handleInvoiceClick={handleInvoiceClick}
         />
         
            
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default IndividualPayment;
